import React, { FC } from "react";
import classNames from "classnames";
import { Input as InputAntd, InputProps } from "antd";

import { BemHelper } from "../../utils";

const bem = new BemHelper("input");

export type Props = InputProps;

export const Input: FC<Props> = ({ prefix = " ", suffix = " ", ...props }) => {
  return (
    <div
      className={classNames([
        bem.block(),
        props.addonBefore && bem.modifier("start"),
        props.addonAfter && bem.modifier("end"),
      ])}
    >
      <InputAntd
        {...props}
        prefix={prefix}
        suffix={suffix}
        status={props["aria-invalid"] ? "error" : undefined}
      />
    </div>
  );
};
